import { KYCStatus } from '@anchorage/graphql/generated';
import { formatEnum } from '@anchorage/utils';

export const getKYCStatusText = (kycStatus: KYCStatus): string => {
  switch (kycStatus) {
    case KYCStatus.DRAFT:
      return 'Draft';
    case KYCStatus.IN_PROGRESS:
      return 'In progress';
    case KYCStatus.IN_REVIEW:
      return 'In review';
    case KYCStatus.PENDING:
      return 'Pending';
    case KYCStatus.COMPLETE:
      return 'Complete';
    case KYCStatus.READY:
      return 'Ready for onboarding';
    default:
      return formatEnum(kycStatus);
  }
};
